module.exports = __webpack_public_path__ + "img/insure_mall@2x.bba12a99.png";